import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/app/src/components/elements/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/elements/FaqBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/elements/PercentageChangeBlock.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/elements/TokenIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/OverviewPage/pageElements/AboutTokenSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/OverviewPage/pageElements/MarketDataCards.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/OverviewPage/pageElements/PriceInfoWithChart.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/OverviewPage/pageElements/PriceOverviewSection.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/OverviewPage/OverviewPage.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/OverviewPage/pageElements/SwapCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/OverviewPage/SingleTokenProductSchemaMarkup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/OverviewPage/WebPageSchemaMarkup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/SearchBox/SearchBox.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SearchBox/SearchBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TokenSwiper"] */ "/app/src/components/TokenSwiper/TokenSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TokenSwiperLink"] */ "/app/src/components/TokenSwiper/TokenSwiperLink.tsx");
